import { Component, OnInit } from '@angular/core';
import { NgSelectOption } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { lastValueFrom } from 'rxjs';
import { FinzyService } from 'src/app/core/services/finzy.service';
import { UserService } from 'src/app/core/services/user.service';
import { environment } from 'src/environments/environment';
import swal from 'sweetalert2';

export interface PaymentRequest {
  txnId: string;
  amount: string;
  productInfo: string;
  firstName: string;
  email: string;
  phone: string;
  udf1: string;
  udf2: string;
  udf3: string;
  udf4: string;
  udf5: string;
  hash: string;
  customNotes: string;
}

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrl: './payment.component.scss'
})
export class PaymentComponent implements OnInit {
  constructor(private spinner: NgxSpinnerService, private finzyService: FinzyService, private router: Router, private userService: UserService, private route: ActivatedRoute) {

  }

  paymentRequest: PaymentRequest;
  processingFee: string;
  success: boolean;
  txnId: string;

  async ngOnInit() {
    this.spinner.hide();
    this.route.queryParamMap.subscribe(params => {
      this.success = params.get('issuccessurl') === "true";
      this.txnId = params.get('txnid');
    });

    if (this.success && this.txnId) {
      this.spinner.show();
      try {
        var res = await lastValueFrom(this.finzyService.UpdatePayment({ txnId: this.txnId }));
        if (res['data'] === 'success') {
          this.spinner.hide();
          return this.router.navigateByUrl("/assist-journey/assist-success");
        }
      } catch (error) {

      }
    }
    else {

      this.spinner.show();
      try {
        var res = await lastValueFrom(this.finzyService.initiatePayment());
        if (res['data']) {
          this.paymentRequest = res['data'];
          console.log(this.paymentRequest);
          this.processingFee = this.paymentRequest.amount;
          this.spinner.hide();
        }
        else {
          this.spinner.hide();
          swal.fire('Error', 'Error initiating payment. Please try again later.');
        }
      }
      catch (error) {
        if (error?.status === 401) {
          this.spinner.hide();
          this.router.navigateByUrl('/assist-journey/session-expired');
        }

        if (error.status === 0) {
          this.spinner.hide();
          swal.fire('Error', 'Network Error: Please check your internet connection and try again.');
          return;
        }
      }

      this.spinner.hide();
    }
  }

  initiatePayment() {
    const formData = {
      key: environment.paymentKey,
      txnid: this.paymentRequest.txnId,
      amount: this.paymentRequest.amount,
      productinfo: this.paymentRequest.productInfo,
      firstname: this.paymentRequest.firstName,
      email: this.paymentRequest.email,
      phone: this.paymentRequest.phone,
      surl: environment.apiUrl + "finzy/payment/success",
      furl: environment.apiUrl + "finzy/payment/failed",
      custom_note: this.paymentRequest.customNotes,
      hash: this.paymentRequest.hash
    };

    console.log(formData);

    return this.userService.redirectWithPostNoEncrypt(environment.PayUUrl, formData);
  }

}
